// 独立页面路由（看板体系，不在控制台内）
export default [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: () => import('@/pages/dashboard/index.vue'),
  },
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import('@/pages/login/index.vue'),
  },
  {
    path: '/single-home',
    name: 'SingleHomePage',
    component: () => import('@/pages/single-home/index.vue'),
  },
  // ponytail: 报告详情为独立页（不进控制台布局/内部页签），系统内列表与外部免登入口均用新浏览器标签页打开
  {
    path: '/report',
    name: 'ReportDetailPage',
    component: () => import('@/pages/report/index.vue'),
  },
  {
    path: '/disclaimer',
    name: 'DisclaimerPage',
    component: () => import('@/pages/save-rule/disclaimer.vue'),
  },
  {
    path: '/privacy',
    name: 'PrivacyPage',
    component: () => import('@/pages/save-rule/privacy-policy.vue'),
  },
]
